import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS_TWO } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function FlowerChart(props) {
  const [viewData, setViewData] = useState([]);
  const { data = {} } = props;

  useEffect(() => {
    if (data) {
      const chartData = [
        {
          category: 'HBB',
          value1: data?.HBB?.payout,
          value2: data?.HBB?.extra_payout
        },
        {
          category: 'Hayyak',
          value1: data?.Hayyak?.payout,
          value2: data?.Hayyak?.extra_payout
        },
        {
          category: 'Baqati',
          value1: data?.Baqati?.payout,
          value2: data?.Baqati?.extra_payout
        },
        {
          category: 'Upgrade',
          value1: data?.Upgrade?.payout,
          value2: data?.Upgrade?.extra_payout
        },
      ];
      if(props.showVoc) {
        chartData.push({
          category: 'VOC',
          value1: data?.VOC?.payout,
          achievement: data?.Upgrade?.extra_payout || 30,
          value2: undefined
        })
      }
      setViewData(chartData);
    }
  }, [props.data]);

  useLayoutEffect(() => {
    // let chart = am4core.create("chartdiv76", am4charts.XYChart);
    const chart = am4core.create('chartdiv76', am4charts.RadarChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.data = viewData;

    chart.padding(20, 20, 20, 20);

    // Modify chart's colors
    chart.colors.list = CHART_COLORS_TWO;

    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';
    categoryAxis.renderer.labels.template.location = 0.5;
    categoryAxis.renderer.tooltipLocation = 0.5;
    categoryAxis.renderer.cellStartLocation = 0.2;
    categoryAxis.renderer.cellEndLocation = 0.8;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.labels.template.horizontalCenter = 'left';
    valueAxis.min = 0;

    const series1 = chart.series.push(new am4charts.RadarColumnSeries());
    series1.columns.template.tooltipText = '{name}: {valueY.value}';
    series1.columns.template.width = am4core.percent(100);
    series1.name = 'Payout';
    series1.dataFields.categoryX = 'category';
    series1.dataFields.valueY = 'value1';

    const series2 = chart.series.push(new am4charts.RadarColumnSeries());
    series2.columns.template.width = am4core.percent(100);
    series2.columns.template.tooltipText = '{name}: {valueY.value}';
    series2.name = 'Extra payout';
    series2.dataFields.categoryX = 'category';
    series2.dataFields.valueY = 'value2';

    if(props.showVoc) {
      const series3 = chart.series.push(new am4charts.RadarColumnSeries());
      series3.columns.template.width = am4core.percent(100);
      series3.columns.template.tooltipText = '{name}: {valueY.value}';
      series3.name = 'Ahievement';
      series3.dataFields.categoryX = 'category';
      series3.dataFields.valueY = 'achievement';
    }
    
    chart.seriesContainer.zIndex = -1;

    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarX.exportable = false;
    chart.scrollbarY = new am4core.Scrollbar();
    chart.scrollbarY.exportable = false;

    chart.cursor = new am4charts.RadarCursor();
    chart.cursor.xAxis = categoryAxis;
    chart.cursor.fullWidthXLine = true;
    chart.cursor.lineX.strokeOpacity = 0;
    chart.cursor.lineX.fillOpacity = 0.1;
    chart.cursor.lineX.fill = am4core.color('#000000');

    chart.legend = new am4charts.Legend();
    // chart.legend.valueLabels.template.text = "hello";
    // series.legendSettings.labelText = "{category}: {value}";

    chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv76" style={{ direction: 'ltr', width: '100%', height: '500px' }} />;
}
